import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Emkanat from "../../assets/pic/emkanat.jpg"
import {Helmet} from "react-helmet";

const WhyBellmeet = ()=>{
    return(
        <div className='whybellmeet-wrap'>
            <Helmet>
                <title>چرا بل میت</title>
                <meta name="description" content="به چه دلیل باید از بستر کلاس آنلاین و وب کنفرانس بل میت استفاده کنیم." />
            </Helmet>
            <Nav />
            <div className="whybellmeet-dec">
                <h1>
                    چرا BellMeet؟
                </h1>
                <br/>
                <p>
                    با افتخار و اطمینان خاطر عنوان می‌کنیم که پلتفرم جامع برگزاری جلسات مجازی BellMeet‌، تنها پلتفرم جامع بومی و دانش بنیان کشور‌، پیشرو در ارائه خدمات آنلاین جهت برگزاری هر نوع جلسات آنلاین شما نظیر وبینار، وب کنفرانس و کلاس آنلاین است.
                </p>
                <p>
                    برای این گفته خود دلایل محکمی داریم که در ادامه این مطلب برای شما عزیزان عنوان می‌کنیم.
                </p>
                <h2>
                    بدون نیاز به نصب
                </h2>
                <p>
                    پلتفرم جامع برگزاری جلسات آنلاین BellMeet کاملاً تحت وب (وب اپلیکیشن) بوده و جهت استفاده از آن تنها به مرورگر (Browser) نیاز است. تفاوتی ندارد که رویداد آنلاین شما از نوع کلاس آنلاین‌، وبینار، وب کنفرانس یا هر نوع کاربری دیگری باشد، جهت برگزاری رویدادهای آنلاین، نیاز به نصب هیچگونه نرم افزاری در سیستم کاربر نیست.
                </p>
                <p>
                    لازم به ذکر است که این امر در همه دستگاه‌ها فارغ از نوع سیستم عامل صادق است و شما در هر سیستمی که دارید (Windows, Mac, iOS, iPad OS, Android) می‌توانید در رویدادهای آنلاین شرکت کنید.
                </p>
                <p>
                    همچنین نیازی به نصب افزونه‌های مختلف مرورگر نبوده و کافی است به راحتی مرورگر خود را باز کرده و به محیط جلسه آنلاین وارد شوید تا دنیایی از ابزارهای تعاملی پیش روی شما قرار گیرد.
                </p>
                <p>
                    ابزارهای تعاملی زیر بدون نصب هیچ گونه نرم افزاری تنها از طریق مرورگر در اختیار شماست:
                </p>
                <ul>
                    <li>•	تعامل صوتی با کیفیت بالا</li>
                    <li>•	تعامل تصویری با کیفیت بالا</li>
                    <li>•	گفتگو و تعامل متنی (چت)</li>
                    <li>•	پخش ویدئو آنلاین</li>
                    <li>•	به اشتراک گذاری فایل</li>
                    <li>•	امکان ایجاد نمایش پیام یا اعلانات مهم به صورت دوره‌ای در محیط جلسه</li>
                </ul>
                <br/>
                <h2>
                    کاملاً فارسی و سازگار با تمامی زبان‌های راست چین
                </h2>
                <p>
                    محیط کاربری پلتفرم جامع برگزاری جلسات آنلاین BellMeet کاملاً به صورت فارسی است. تمامی عنوان‌ها‌، گزینه‌ها و هر آنچه برای شما نمایش داده می‌شود، کاملاً به زبان فارسی است. ابزار تعامل متنی (چت) نیز کاملاً با زبان فارسی و تمامی زبان‌های راست چین دنیا سازگار است.
                </p>
                <p>
                    پلتفرم جامع BellMeet، علاوه بر زبان فارسی‌ با سایر زبان‌ها نظیر انگلیسی، عربی و ترکی قابل استفاده است. به این صورت که تمامی عنوان‌ها و گزینه‌ها به زبان انگلیسی و ... نمایش داده می‌شود.
                </p>
                <h2>
                    محیط کاربری ساده
                </h2>
                <p>
                    محیط کاربری پلتفرم جامع برگزاری جلسات مجازی BellMeet بسیار ساده و کاربر پسند (User-Friendly) بوده و هیچ المان مبهمی در آن به کار نرفته است. مهم نیست که شما چقدر تجربه کار با سیستم‌های کامپیوتری را داشته باشید، هر ابزار تعاملی که در محیط جلسه مورد نیاز است، به آسانی در اختیار شماست.
                </p>
                <p>
                    چه نقش کاربری شما در رویداد آنلاین استاد (مدیر جلسه) باشد و چه دانش پذیر، محیط کاربری ساده و جذاب BellMeet به ساده‌ترین شکل ممکن، حداکثر تعامل شما را با رویداد آنلاین برقرار می‌کند.
                </p>
                <h2>
                    سرورهای اختصاصی و امنیت اطلاعات
                </h2>
                <p>
                    سرویس آنلاین BellMeet و تمامی داده‌های آن در سرورهای داخلی و اختصاصی با نهایت امنیت نگه داشته می‌شوند. سرورهای اختصاصی سرویس BellMeet شبانه‌روز توسط خبره‌ترین تیم تخصصی DevOps و مهندسان شبکه پایش شده و لذا کمترین نگرانی بابت از دسترس خارج شدن سرویس و همچنین امنیت اطلاعات (داده‌های هویتی افراد و مطالب به اشتراک گذاشته شده در محیط جلسه آنلاین) افراد وجود ندارد.
                </p>
                <h2>
                    کیفیت و پایداری ارتباط
                </h2>
                <p>
                    می‌توان گفت که مهم‌ترین معیار در کیفیت برگزاری یک رویداد آنلاین‌، پایداری آن است. عدم پایداری به هر شکلی نظیر خارج شدن سرویس از دستریس، قطع و وصل مکرر صدا و تصویر، افت کیفیت صوتی و تصویری و ... موجب افت کیفیت و بازدهی جلسه آنلاین و نارضایتی کاربران می‌شود.
                </p>
                <p>
                    به همین جهت توسعه دهندگان پلتفرم جمع ‌BellMeet به تمامی پارامترهای موثر در پایداری ارتباط و همچنین شرایط اینترنت داخلی کشور توجه ویژه‌ای داشته‌اند تا بهینه‌ترین سرویس برگزاری رویدادهای آنلاین را ارائه دهند.
                </p>
                <p>
                    توجه ویژه تیم توسعه دهنده به پارامترهای موثر در پایداری و همچنین وجود سرورهای قدرتمند اختصاصی و داخلی که شبانه‌روز توسط مهندسان خبره شبکه و تیم تخصصی DevOps پایش می‌شوند، موجب تولد پلتفرم بهینه و پایدار BellMeet شد که جهت استفاده از آن نیاز به دستگاهی با سخت افزار قوی نیست.
                </p>
                <p>
                    لازم به ذکر است که پلتفرم جامع BellMeet کاملاً به صورت هوشمند و خودکار بر اساس سرعت و پهنای‌باند کاربر، کیفیت تصویر دوربین وب کم را تنظیم کرده تا نهایت پایداری در تعامل‌های تصویری حفظ شود.
                </p>
                <h2>
                    برگزاری رویداد آنلاین با لوگو اختصاصی شما
                </h2>
                <p>
                    در پلتفرم جامع برگزاری رویدادهای آنلاین BellMeet، این امکان وجود دارد که در قسمت اطلاعات عمومی جلسه، لوگو اختصاصی سازمان شما درج شود. این امر بر رسمیت رویداد آنلاین شما تاثیر زیادی دارد.
                </p>
                <h2>
                    پنل کاربری (مدیریت) ساده
                </h2>
                <p>
                    فرآیند ایجاد اتاق (محیط جلسه آنلاین) و مدیریت کاربران آن در پلتفرم جامع BellMeet بسیار ساده است. به واسطه محیط کاربری ساده‌ی پنل مدیریت BellMeet که تماماً به زبان فارسی در اختیار شما قرار می‌گیرد، به سادگی امکان ایجاد اتاق‌های متعدد، ایجاد و مدیریت کاربران و مشاهده گزارش‌هایی از رویدادهای آنلاین وجود دارد.
                </p>
                <p>
                    در انتها مقایسه‌ای بین امکانات پلتفرم جامع BellMeet و سایر سرویس‌هایی که در حوزه برگزاری رویدادهای آنلاین فعالیت می‌کنند، برای شما عزیزان آورده شده است.
                </p>
{/*                <h2>مقایسه BellMeet با سایر پلتفرم ها:</h2>
                <br/>
                <img src={Emkanat} alt=""/>*/}
            </div>
            <Footer />
        </div>
    )
}

export default WhyBellmeet